import controller from './wf-node-select.controller';
import template from './wf-node-select.html';

export default {
	controller,
	template,
	bindings: {
		actions:  '=?modelActions',
		data:     '<ngModel',
		disabled: '<ngDisabled',
		form:     '<',
		index:    '<?',
		name:     '@?',
		options:  '<?',
	},
	require:  {
		ngModelCtrl: '?ngModel',
		kformCtrl:   '^^?kform',
	},
};
